'use strict';

import template from './fast_pay_modal.html';

export default {
  bindings: {
    paymentData: '<',
    done: '&',
    paymentProvider: '<',
    reloadParams: '<',
  },
  template: template,
  controller: function (payModal, reloadPage, userModel, paymentTypes, currencyModel) {
    'ngInject';

    this.subscriptionPayment = paymentTypes.subscription === this.paymentData.meta.PAYMENT_TYPE;
    this.bookingPayment = paymentTypes.booking === this.paymentData.meta.PAYMENT_TYPE;

    if (this.subscriptionPayment) {
      this.paymentData.currency = currencyModel.getValue();
    }

    this.savedCard = userModel.item.membership.activeContract;

    this.formatCardExpiry = (expiry) => {
      const { month, year } = expiry;
      return `${month}/${year}`;
    };

    this.pay = () => {
      this.isSaving = true;
      this.errorShake = false;
      this.paymentProvider.sendFastPaymentData(this.paymentData).then((response) => {
        if (!response.data.result) {
          response.data.result = response.data;
        }
        this.done();
        reloadPage.doIt(this.paymentProvider.getReloadURL(response.data.result.resultCode));
      }).catch((response) => {
        if (!response.data.result) {
          response.data.result = response.data;
        }
        this.errorShake = true;
        if (response.data.result.refusalReason) {
          this.error = response.data.result.refusalReason;
        }
        if (response.data.result.errorType === 'validation') {
          this.error = response.data.result.message;
        }
        this.isSaving = false;
      });
    };

    this.changePaymentDetails = () => {
      this.done();
      payModal.open(this.paymentData, this.paymentProvider);
    };
  }
};



// WEBPACK FOOTER //
// ./app/src/components/fast_pay_modal/fast_pay_modal.js